module.exports = __webpack_public_path__ + "assets/img/home-product-advantage-en.bccb74a0.png";